module.exports = __webpack_public_path__ + "static/media/atharva_muglikar.fea81004.jpeg";